// extracted by mini-css-extract-plugin
export default {"pageMaxWidth":"1264px","gapSpacer":"calc(8px * 4)","container":"_3Vxbxjmj490HS271w6iZjg=="};